export const REVIEWS_SWIPER_CONTAINER = 'REVIEWS_SWIPER_CONTAINER';
